import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

interface OverlayProps {
  content: string | React.ReactNode
  placement?: 'top' | 'right' | 'bottom' | 'left'
}

const Overlay: React.FC<OverlayProps> = ({content, placement = 'right'}) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={`tooltip-${placement}`}>
          <span>{content}</span>
        </Tooltip>
      }
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#5A5A5A'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
        className='icon icon-tabler icons-tabler-outline icon-tabler-info-circle mx-2'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
        <path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0' />
        <path d='M12 9h.01' />
        <path d='M11 12h1v4h1' />
      </svg>
    </OverlayTrigger>
  )
}

export default Overlay
